(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byane-customer-care"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('byane-customer-care')) {
    customElements.define('byane-customer-care', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const tabs = Array.from(this.querySelectorAll('[data-care-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-care-panel]'));
        const select = (kind, focus = false) => {
          tabs.forEach(tab => {
            const active = tab.dataset.careTab === kind;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            if (active && focus) tab.focus();
          });
          panels.forEach(panel => {
            const active = panel.dataset.carePanel === kind;
            panel.hidden = !active;
            panel.querySelectorAll('input, select, textarea, button').forEach(field => field.disabled = !active);
          });
        };
        const hash = window.location.hash;
        select(hash.includes('CareForm-after-') ? 'after' : 'before');
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab.dataset.careTab));
          tab.addEventListener('keydown', event => {
            let target;
            if (['ArrowDown', 'ArrowRight'].includes(event.key)) target = (index + 1) % tabs.length;
            if (['ArrowUp', 'ArrowLeft'].includes(event.key)) target = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = tabs.length - 1;
            if (target !== undefined) {
              event.preventDefault();
              select(tabs[target].dataset.careTab, true);
            }
          });
        });
        this.querySelectorAll('[data-care-after-link]').forEach(link => link.addEventListener('click', () => select('after')));
        this.querySelectorAll('form').forEach(form => {
          const response = form.querySelector('[data-care-response]');
          if (response && hash.startsWith('#CareForm-')) response.hidden = hash !== '#' + form.id;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byane-product-finder"] && !Shopify.designMode) return;
  try {
    
  const normalizeValue = (value) => String(value || '').trim().toLowerCase();
  const splitValues = (value) => normalizeValue(value).split(/[,;|]/).map((item) => item.trim()).filter(Boolean);

  document.querySelectorAll('[data-byane-product-finder]').forEach((section) => {
    const tabs = section.querySelectorAll('[data-byane-mode-trigger]');
    const modes = section.querySelectorAll('[data-byane-mode]');
    const form = section.querySelector('[data-byane-finder-form]');
    const resultsWrap = section.querySelector('[data-byane-results]');
    const cards = Array.from(section.querySelectorAll('[data-byane-result]'));
    const summary = section.querySelector('[data-byane-summary]');
    const empty = section.querySelector('[data-byane-empty]');
    const error = section.querySelector('[data-byane-error]');
    const reset = section.querySelector('[data-byane-reset]');
    let activeMode = 'specs';

    const dataKeyMap = {
      productType: 'productType',
      barLength: 'barLength',
      pitch: 'pitch',
      gauge: 'gauge',
      driveLinks: 'driveLinks'
    };

    const showError = (message) => {
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    };

    const clearResults = () => {
      cards.forEach((card) => {
        card.hidden = true;
      });
      if (resultsWrap) resultsWrap.hidden = true;
      if (summary) {
        summary.hidden = true;
        summary.textContent = '';
      }
      if (empty) empty.hidden = true;
    };

    const setMode = (mode) => {
      activeMode = mode;
      tabs.forEach((tab) => {
        const selected = tab.dataset.byaneModeTrigger === mode;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      modes.forEach((panel) => {
        panel.hidden = panel.dataset.byaneMode !== mode;
      });
      clearResults();
      showError('');
    };

    const addOption = (select, value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    };

    Object.entries(dataKeyMap).forEach(([filterName, dataKey]) => {
      const select = section.querySelector(`[data-byane-filter="${filterName}"]`);
      if (!select) return;
      const values = new Set();
      cards.forEach((card) => {
        splitValues(card.dataset[dataKey]).forEach((item) => values.add(item));
      });
      Array.from(values).sort((a, b) => a.localeCompare(b, undefined, { numeric: true })).forEach((value) => addOption(select, value));
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setMode(tab.dataset.byaneModeTrigger));
    });

    if (reset) {
      reset.addEventListener('click', () => {
        form.reset();
        clearResults();
        showError('');
      });
    }

    if (!form) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      showError('');

      let matches = [];

      if (activeMode === 'code') {
        const codeInput = section.querySelector('[data-byane-code-input]');
        const code = normalizeValue(codeInput ? codeInput.value : '');
        if (!code) {
          clearResults();
          showError(section.dataset.codeRequiredMessage);
          return;
        }
        matches = cards.filter((card) => {
          return normalizeValue(card.dataset.sku) === code || normalizeValue(card.dataset.fnsku) === code || normalizeValue(card.dataset.asin) === code;
        });
      } else {
        const activeFilters = {};
        Object.keys(dataKeyMap).forEach((filterName) => {
          const input = section.querySelector(`[data-byane-filter="${filterName}"]`);
          const value = normalizeValue(input ? input.value : '');
          if (value) activeFilters[filterName] = value;
        });
        if (Object.keys(activeFilters).length === 0) {
          clearResults();
          showError(section.dataset.filterRequiredMessage);
          return;
        }

        matches = cards.filter((card) => {
          const selectMatched = Object.entries(activeFilters).every(([filterName, value]) => {
            const dataKey = dataKeyMap[filterName];
            return splitValues(card.dataset[dataKey]).includes(value);
          });
          return selectMatched;
        });
      }

      cards.forEach((card) => {
        card.hidden = !matches.includes(card);
      });

      if (resultsWrap) resultsWrap.hidden = matches.length === 0;
      if (empty) empty.hidden = matches.length !== 0;
      if (summary) {
        summary.hidden = false;
        summary.textContent = matches.length === 1
          ? section.dataset.oneMatchMessage
          : `${matches.length} ${section.dataset.manyMatchesSuffix}`;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');

  function loadProductRecommendations() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;
        }

        theme.initProductTitleAlignmentWatcher(sectionEl, '.productRecommendations');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
